<template>
  <div class="space-y-4 min-w-0">
    <h3 class="text-lg font-semibold text-gray-800">WiFi Network</h3>

    <div class="min-w-0">
      <label for="wifi-ssid" class="block text-sm font-medium text-gray-700 mb-1">
        Network Name (SSID) *
      </label>
      <input
        id="wifi-ssid"
        type="text"
        :value="modelValue.ssid"
        @input="updateField('ssid', $event.target.value)"
        class="w-full min-w-0 p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        placeholder="MyWiFiNetwork"
        required
        maxlength="32"
        aria-required="true"
      />
    </div>

    <div class="min-w-0">
      <label for="wifi-password" class="block text-sm font-medium text-gray-700 mb-1">
        Password
      </label>
      <div class="relative min-w-0">
        <input
          id="wifi-password"
          :type="showPassword ? 'text' : 'password'"
          :value="modelValue.password"
          @input="updateField('password', $event.target.value)"
          class="w-full min-w-0 p-2 pr-12 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder="WiFi password"
          maxlength="63"
        />
        <button
          type="button"
          @click="showPassword = !showPassword"
          class="absolute inset-y-0 right-0 flex items-center justify-center min-w-[44px] min-h-[44px] text-gray-400 hover:text-gray-600"
          aria-label="Toggle password visibility"
        >
          <EyeIcon v-if="!showPassword" class="h-5 w-5" />
          <EyeSlashIcon v-else class="h-5 w-5" />
        </button>
      </div>
    </div>

    <div class="min-w-0">
      <label for="wifi-security" class="block text-sm font-medium text-gray-700 mb-1">
        Security Type
      </label>
      <select
        id="wifi-security"
        :value="modelValue.security"
        @change="updateField('security', $event.target.value)"
        class="w-full min-w-0 p-2 min-h-[44px] border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      >
        <option value="WPA">WPA/WPA2</option>
        <option value="WEP">WEP</option>
        <option value="nopass">Open (No Password)</option>
      </select>
    </div>

    <div class="min-w-0">
      <label for="wifi-hidden" class="flex items-center space-x-2 min-h-[44px] cursor-pointer">
        <input
          id="wifi-hidden"
          type="checkbox"
          :checked="modelValue.hidden"
          @change="updateField('hidden', $event.target.checked)"
          class="rounded border-gray-300 text-blue-600 focus:ring-blue-500 w-5 h-5"
          aria-describedby="wifi-hidden-desc"
        />
        <span id="wifi-hidden-desc" class="text-sm font-medium text-gray-700">Hidden Network</span>
      </label>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { EyeIcon, EyeSlashIcon } from "@heroicons/vue/24/outline";

export default {
  name: "WiFiForm",
  components: {
    EyeIcon,
    EyeSlashIcon,
  },
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  setup() {
    const showPassword = ref(false);

    return {
      showPassword,
    };
  },
  methods: {
    updateField(field, value) {
      this.$emit("update:modelValue", {
        ...this.modelValue,
        [field]: value,
      });
    },
  },
};
</script>
